import {
    WidgetConfig,
    WidgetExpression,
    WidgetPropertiesInfo
} from 'plugin-alerts-dashboard-channels/channelAlerts/types'
import { removeTzFromSpan } from './widgetRequestHelper'

export const getWidgetInfoHelper = (
    dashboard: LiveDashboard,
    widget: LiveWidget<WidgetConfig>,
    expression: WidgetExpression,
    widgetRequest: LiveWidgetRequest
): WidgetPropertiesInfo => {
    const widgetConfig = widget.jsonConfig

    const isDepth = !!widgetConfig?.spanPicker?.configs?.depth

    return {
        dashboardId: dashboard.id,
        dashboardName: dashboard.title,
        widgetId: widget.id,
        widgetName: widget.name,
        isTvd: widgetConfig?.spanPicker?.configs?.depth?.selectedMeasurementOption === 'TVD',
        lookupValues: widgetRequest.lookupValues,
        expression: expression.expression,
        reducer: expression.reducer ?? widgetConfig.properties[0]?.query.reducer,
        spanDepth: isDepth ? removeTzFromSpan(expression.span) : '',
        isSpanDepth: isDepth
    }
}
